import React from "react";
import * as z from "zod";
import { cn } from "@/lib/utils";
import { ImageSchema } from "../lib/validation/image-schema";

export function BackgroundImageLayer({
  image,
  className = "",
}: {
  image: z.infer<typeof ImageSchema>;
  className?: string;
}) {
  if (!image?.source?.src) return null;

  return (
    <div
      className={cn(
        "w-full h-full absolute top-0 left-0 right-0 bottom-0",
        className
      )}
    >
      <img
        alt="background image"
        src={image.source.src}
        className={cn("overflow-hidden object-cover w-full h-full")}
        style={{
          opacity: (image.style?.opacity || 30) / 100,
        }}
      />
    </div>
  );
}
